import React, {useId} from "react";
import styled from "styled-components";

const Styled = {
	TileRoot: styled.div<{ onClick?: () => void, tiny?: boolean }>`
		position: relative;
		isolation: isolate;
		display: flex;
		align-items: center;
		justify-content: center;
		
		width: 100%;
		min-width: 0;
		height: ${ p => p.tiny ? "60px" : "102px"};
		
		color: #f5bf83;
		font-family: "Courier New", monospace;
		cursor: ${ p => !! p.onClick ? "pointer" : "auto"};
	`,

	TileFrame: styled.svg`
		position: absolute;
		inset: 0;
		z-index: -1;
		width: 100%;
		height: 100%;
		pointer-events: none;
	`,

	TileIcon: styled.div<{ tiny?: boolean }>`
		position: absolute;
		top: ${ p => p.tiny ? "14px" : "23px"};
		left: 24px;
		
		width: ${ p => p.tiny ? "30px" : "52px"};
		height: ${ p => p.tiny ? "30px" : "52px"};
		color: #99552b;
		opacity: 0.85;
		
		svg {
			width: 100%;
			height: 100%;
			stroke-width: 2.8;
		}
	`,

	TileContent: styled.div`
		position: relative;
		z-index: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		
		margin-left: 48px;
		margin-top: 4px;
		min-width: 0;
	`,

	TileValue: styled.div<{ $color?: string, tiny?: boolean }>`
		color: ${({ $color }) => $color || "#ffc184"};
		font-family: "Courier New", monospace;
		font-size: ${ p => p.tiny ? "26px" : "31px"};
		font-weight: 700;
		line-height: 1.1;
		letter-spacing: 0.5px;
		text-shadow: 0 0 10px #e68a3420;
	`,

	TileLabel: styled.div`
        margin-top: 7px;
        color: #d0a17a;
        font-size: 10px;
        font-weight: 600;
        letter-spacing: 0.5px;
        text-align: center;
        white-space: nowrap;
        text-transform: uppercase;
    `
}

export const MiniPanel = ({ value, label, Icon, valueColor, $myStatus, onClick, tiny }
							:{ value: string, label: string, Icon: React.ReactNode, valueColor: string, $myStatus?: boolean, onClick?: () => void, tiny?: boolean }) => {

	const gradientId = useId().replace(/:/g, "");

	const styleAlign = {
		viewBox: tiny ? "0 0 205 75" : "0 0 205 102"
	}

	return (
		<Styled.TileRoot onClick={ onClick } tiny={ tiny }>
			<Styled.TileFrame
				viewBox="0 0 205 102"
				preserveAspectRatio="none"
				aria-hidden="true"
			>
				<defs>
					<linearGradient
						id={gradientId}
						x1="0"
						y1="0"
						x2="1"
						y2="1"
					>
						{ $myStatus
							? <>
								<stop offset="0%" stopColor="#8A7A22" />
								<stop offset="100%" stopColor="#261F09" />
							</>
							: <>
								<stop offset="0%" stopColor="#3d1e0e" />
								<stop offset="100%" stopColor="#291308" />
							</> }
					</linearGradient>
				</defs>

				{/* Grundfläche und Außenrahmen */}
				<path
					d="
						M 8 1
						H 197
						L 204 8
						V 94
						L 197 101
						H 8
						L 1 94
						V 8
						Z
						"
					fill={`url(#${gradientId})`}
					stroke="#9a501e"
					strokeWidth="1"/>

				{/* Verstärkte obere linke Ecke */}
				<path
					d="M 2 25 V 9 L 10 2 H 28"
					fill="none"
					stroke="#e78a36"
					strokeWidth="2"/>

				{/* Technische Linie oben rechts */}
				<path
					d="M 188 7 H 198 V 15"
					fill="none"
					stroke="#c8762a"
					strokeWidth="1.5"/>

				{/* Untere linke Leiterbahn */}
				<path
					d="M 7 88 V 95 H 31"
					fill="none"
					stroke="#a65c2a"
					strokeWidth="1"/>

				{/* Kleine Markierungen */}
				<path
					d="M 13 7 V 11 M 17 7 V 9"
					stroke="#9b5829"
					strokeWidth="1"/>
			</Styled.TileFrame>

			{ Icon && <Styled.TileIcon tiny={ tiny }>{ Icon }</Styled.TileIcon> }

			<Styled.TileContent>
				<Styled.TileValue $color={valueColor} tiny={ tiny }>
					{value}
				</Styled.TileValue>
				<Styled.TileLabel>{label}</Styled.TileLabel>
			</Styled.TileContent>
		</Styled.TileRoot>
	);
}